import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Box,
  TextField,
  FormGroup,
  Checkbox,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { RegisterFormContext } from "../../Context/RegisterFormContext";
import ButtonsGroup from "./ButtonsGroup";

export default function ScreenZero() {
  const { formData, setFormData, one, setAvailableScreens, availableScreens } = useContext(RegisterFormContext);

  const handlePackageChange = (_, newValue) => {
    if (newValue !== null) {
      setFormData((prevData) => ({
        ...prevData,
        program: newValue,
      }));
    }
  };

  function handleNext() {
    setAvailableScreens((prev) => ({ ...prev, screen1: true }));
    setTimeout(() => {
      if (one.current) {
        one.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);
  }

  return (
    <div
      style={{
        marginBottom: "1rem",
        minHeight: availableScreens.screen1 ? "80vh" : "max-content",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        display: "flex",
        // alignItems: availableScreens.screen2 ? "center" : "flex-start"
      }}
    >
      <div style={{width: '100%'}}>
        <Typography variant="h6" style={{ fontSize: "clamp(1.1rem, 4vw, 2rem" }}>
          Choose a program
        </Typography>

        <ToggleButtonGroup
          value={formData.program || ""}
          exclusive
          onChange={handlePackageChange}
          style={{ display: "flex", gap: "1rem", fontSize: "clamp(1.1rem, 4vw, 2rem" }}
        >
          <ToggleButton
            value="IB DP"
            style={toggleStyle}
            sx={toggleButtonStyles}
          >
            IB DP
          </ToggleButton>
          <ToggleButton
            value="IB MYP"
            style={toggleStyle}
            sx={toggleButtonStyles}
          >
            IB MYP
          </ToggleButton>
          <ToggleButton
            value="Others"
            style={toggleStyle}
            sx={toggleButtonStyles}
          >
            Others
          </ToggleButton>
        </ToggleButtonGroup>

        <ButtonsGroup
          nextDisabled={!formData?.program}
          onlyNext={true}
          onNext={handleNext}
        />
      </div>
    </div>
  );
}

const toggleButtonStyles = {
  borderRadius: "20px",
  textTransform: "none",
  backgroundColor: "#e0e0e0",
  "&.Mui-selected": {
    backgroundColor: "#14549f",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#10498a",
    },
  },
};

const toggleStyle = {
  borderRadius: "2rem",
  minWidth: "clamp(50px, 20vw, 100px)",
  padding: "0.5rem 1rem",
};
